/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { authenticateTelegramResponseDataSchema } from '../authenticateTelegramApi/authenticate-telegram-response';

export const authenticateTelegramV2ResponseDataSchema =
  authenticateTelegramResponseDataSchema.extend({
    hasOauthLink: z.boolean(),
    oauthProvider: z.enum(['google', 'apple']).nullable(),
  });

export type IAuthenticateTelegramV2ResponseData = z.infer<
  typeof authenticateTelegramV2ResponseDataSchema
>;

export const authenticateTelegramV2ResponseSchema = createApiResponseSchema(
  authenticateTelegramV2ResponseDataSchema,
) as z.ZodSchema<IAPI<IAuthenticateTelegramV2ResponseData>>;

export type IAuthenticateTelegramV2Response = IAPI<IAuthenticateTelegramV2ResponseData>;
